import { initMenu } from './menu.js';
import { initScrollTrigger } from './scroll-trigger.js';
import { initFaq } from './faq.js';

document.addEventListener('DOMContentLoaded', () => {
  initMenu();
  initScrollTrigger();
  initFaq();
});
